var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8889 14.645C29.6526 14.3012 23.9751 6.24982 14.9999 6.24982C7.29854 6.24982 0.43593 14.255 0.147175 14.5962C-0.0490584 14.8287 -0.0490584 15.17 0.147175 15.4037C0.43593 15.745 7.29854 23.7501 14.9999 23.7501C22.7013 23.7501 29.5639 15.745 29.8526 15.4037C30.0339 15.1887 30.0501 14.8775 29.8889 14.645ZM14.9999 22.5001C8.8261 22.5001 2.95597 16.6125 1.46473 15C2.95351 13.3862 8.81737 7.49987 14.9999 7.49987C22.2238 7.49987 27.3226 13.3787 28.5676 14.9662C27.1301 16.5275 21.2263 22.5001 14.9999 22.5001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 9.99988C12.2425 9.99988 10 12.2424 10 14.9999C10 17.7575 12.2425 20 15.0001 20C17.7576 20 20.0001 17.7575 20.0001 14.9999C20.0001 12.2424 17.7576 9.99988 15.0001 9.99988ZM15.0001 18.7501C12.9325 18.7501 11.25 17.0675 11.25 15C11.25 12.9325 12.9325 11.2499 15.0001 11.2499C17.0676 11.2499 18.7501 12.9325 18.7501 15C18.7501 17.0675 17.0676 18.7501 15.0001 18.7501Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.043b1824b15ccdd4a40b61b246af7ef3.svg";
export { ForwardRef as ReactComponent };